import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Spin } from "antd";
import { tokenStorage } from "../../utils/http.js";
import { queryClient } from "../../utils/api.js";

const Logo = () => (
  <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-gh-primary to-gh-accent flex items-center justify-center mb-4 shadow-gh-md">
    <span className="text-white font-bold text-2xl">GH</span>
  </div>
);

const Logout = () => {
  const navigate = useNavigate();
  const [showSpinner, setShowSpinner] = useState(false);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        // Clear the react-query cache so the next signed-in user doesn't see
        // leftover data from the previous session.
        queryClient.clear();

        // Clear auth state
        tokenStorage.clear();

        // Brief delay so the user sees the logout feedback rather than a flash
        await new Promise((r) => setTimeout(r, 350));
        if (!cancelled) setShowSpinner(true);

        navigate("/signin", { replace: true });
      } catch (error) {
        console.error("Error during logout:", error);
        navigate("/signin", { replace: true });
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gh-bg via-white to-gh-primary-lighter/20 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      <div className="bg-white/90 dark:bg-gray-800/90 backdrop-blur-sm rounded-2xl shadow-gh-lg px-10 py-8 max-w-sm w-full text-center border border-white/60">
        <Logo />
        <h1 className="text-xl font-bold text-gray-900 dark:text-white tracking-tight">
          Signing you out
        </h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">
          Cleaning up your session…
        </p>
        <div className="mt-6 flex justify-center">
          {showSpinner ? <Spin size="large" /> : <Spin />}
        </div>
      </div>
    </div>
  );
};

export default Logout;
